import Rating from '__models__/rating';

export class Application {
  static entityName = 'application';

  id: string;
  jobId: string;
  rating: Rating;
}
